import { asField } from 'informed';
import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { useContext, useEffect } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _InputMessage from '../InputMessage/index.js';
import CheckboxField from './_CheckboxField.js';
import { CheckboxGroupContext } from './CheckboxGroup.js';

var _excluded = ["checkboxInputStyles", "checkboxButtonStyles", "fieldApi", "fieldState"],
  _excluded2 = ["checked", "onChange", "onBlur", "initialValue", "forwardedRef", "theme", "title", "label", "field", "hideLabel"];
var _templateObject;
var handleChange = function handleChange(setValue, onChange, parentOnChange, field) {
  return function (e) {
    setValue(e.target.checked);
    if (onChange) {
      onChange(e);
    }
    if (parentOnChange) {
      parentOnChange({
        fieldName: field,
        value: e.target.checked
      });
    }
  };
};
var handleBlur = function handleBlur(setTouched, onBlur, parentOnBlur) {
  return function (e) {
    setTouched(true);
    if (onBlur) {
      onBlur(e);
    }
    if (parentOnBlur) {
      parentOnBlur(e);
    }
  };
};
var CheckboxWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-self: center;\n  & + & {\n    margin-top: 1rem;\n  }\n"])));
var Checkbox = function Checkbox(_ref) {
  var checkboxInputStyles = _ref.checkboxInputStyles,
    checkboxButtonStyles = _ref.checkboxButtonStyles,
    fieldApi = _ref.fieldApi,
    fieldState = _ref.fieldState,
    props = _objectWithoutProperties(_ref, _excluded);
  var value = fieldState.value,
    error = fieldState.error;
  var setValue = fieldApi.setValue,
    setTouched = fieldApi.setTouched;
  var checked = props.checked,
    onChange = props.onChange,
    onBlur = props.onBlur,
    initialValue = props.initialValue,
    forwardedRef = props.forwardedRef,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? themes["default"] : _props$theme,
    title = props.title,
    label = props.label,
    field = props.field,
    hideLabel = props.hideLabel,
    rest = _objectWithoutProperties(props, _excluded2);
  var _useContext = useContext(CheckboxGroupContext),
    parentError = _useContext.error,
    parentOnChange = _useContext.onChange,
    parentOnBlur = _useContext.onBlur,
    registerFieldToCheckboxGroup = _useContext.registerFieldToCheckboxGroup,
    deregisterFieldToCheckboxGroup = _useContext.deregisterFieldToCheckboxGroup;
  /**
   * Registers the checkBoxRef to the CheckboxGroup
   */
  useEffect(function () {
    if (registerFieldToCheckboxGroup) {
      registerFieldToCheckboxGroup(field, {
        fieldApi: fieldApi,
        fieldState: fieldState
      });
    }
    return function () {
      if (deregisterFieldToCheckboxGroup) {
        deregisterFieldToCheckboxGroup(field);
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(CheckboxWrapper, null, /*#__PURE__*/React.createElement(CheckboxField, _extends({}, rest, {
    checkboxButtonStyles: checkboxButtonStyles,
    checkboxInputStyles: checkboxInputStyles,
    field: field,
    value: value,
    initialValue: initialValue,
    error: error,
    parentError: parentError,
    theme: theme,
    label: label,
    title: title,
    hideLabel: hideLabel,
    onChange: handleChange(setValue, onChange, parentOnChange, field),
    onBlur: handleBlur(setTouched, onBlur, parentOnBlur)
  })), /*#__PURE__*/React.createElement(_InputMessage, {
    id: "".concat(field, "-error-message"),
    role: 'alert',
    "aria-live": 'assertive',
    error: true,
    hidden: true
  }, error ? error : ''));
};
// @ts-ignore
var _Checkbox = withDefaultTheme(asField(Checkbox));

export default _Checkbox;
